<script setup lang="ts">
import { selectionActions } from "@/action/selectionActions";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";

import ShareMenu from "./ShareMenu.vue";
</script>

<template>
  <ActionMenuDropdown :action="selectionActions.share">
    <ShareMenu />
  </ActionMenuDropdown>
</template>
